import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import config from './assets/nicoleaptekardotcom.json';

import ScrollToTop from './components/ui/ScrollToTop';
import Banner from './components/Banner';
import Landing from './components/Landing';
import About from './components/About';
import Exhibitions from './components/Exhibitions';
import Piece from './components/Piece';
import Category from './components/Category';

class App extends Component {
  render() {
    let categories = [].concat(...config.pieces.map(p => p.categories));
    categories = [...new Set(categories)];

    return (
      <Router>
        <ScrollToTop>
          <Banner config={config} />
          <Switch>
            <Route exact path="/"
              render={() => <Landing config={config} /> }
            />
            <Route exact path="/about" component={About} />
            <Route exact path="/exhibitions" component={Exhibitions} />
            { config.pieces.map((piece,i) =>
              <Route exact key={`route${i}`}
                path={`/piece/${piece.url}`}
                render={() => <Piece piece={piece} config={config} /> }
              />
            )}
            { categories.map((category, i) =>
              <Route exact key={`cat${i}`}
                path={`/category/${category}`}
                render={() => <Category category={category} config={config} /> }
              />
            )}
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js